export interface AcquisitionInput {
  landing_path?: unknown;
  referrer_host?: unknown;
  utm_source?: unknown;
  utm_medium?: unknown;
  utm_campaign?: unknown;
  utm_content?: unknown;
  utm_term?: unknown;
}

export interface Acquisition {
  landing_path: string | null;
  referrer_host: string | null;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  utm_content: string | null;
  utm_term: string | null;
}

const STORAGE_KEY = "weibotop_first_touch";

function clean(value: unknown, length: number): string | null {
  if (typeof value !== "string") return null;
  const result = value.trim().slice(0, length);
  return result || null;
}

export function sanitizeAcquisition(input: AcquisitionInput): Acquisition {
  const path = clean(input.landing_path, 255);
  return {
    landing_path: path?.startsWith("/") && !path.startsWith("//") ? path : null,
    referrer_host: clean(input.referrer_host, 255),
    utm_source: clean(input.utm_source, 120),
    utm_medium: clean(input.utm_medium, 120),
    utm_campaign: clean(input.utm_campaign, 120),
    utm_content: clean(input.utm_content, 120),
    utm_term: clean(input.utm_term, 120),
  };
}

export function captureFirstTouch(url: URL, referrer = ""): Acquisition {
  let referrerHost: string | null = null;
  try {
    referrerHost = referrer ? new URL(referrer).hostname : null;
  } catch {
    referrerHost = null;
  }
  return sanitizeAcquisition({
    landing_path: url.pathname,
    referrer_host: referrerHost,
    utm_source: url.searchParams.get("utm_source"),
    utm_medium: url.searchParams.get("utm_medium"),
    utm_campaign: url.searchParams.get("utm_campaign"),
    utm_content: url.searchParams.get("utm_content"),
    utm_term: url.searchParams.get("utm_term"),
  });
}

export function persistFirstTouch(): void {
  if (typeof window === "undefined") return;
  try {
    if (!localStorage.getItem(STORAGE_KEY)) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(captureFirstTouch(new URL(window.location.href), document.referrer)));
    }
  } catch {
    // Storage can be unavailable in privacy mode.
  }
}

export function getStoredAcquisition(): Acquisition | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? sanitizeAcquisition(JSON.parse(raw)) : null;
  } catch {
    return null;
  }
}

